import { JsonObject, JsonProperty } from 'json2typescript';
import * as uuid from 'uuid';

import { Id } from './id';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { TypeDistributionInterface } from '../../../core';

@JsonObject('TypeDistribution')
export class TypeDistribution implements TypeDistributionInterface {
    private readonly _id: Id = undefined;

    @JsonProperty('BankCode', StringAdapter, true)
    private _bankCode: string = undefined;

    @JsonProperty('Code', StringAdapter, true)
    private _code: string = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Value', Number, true)
    private _value: number = undefined;

    @JsonProperty('Weight', Number, true)
    private _weight: number = undefined;

    constructor() {
        this._id = new Id(uuid.v4());
    }

    get id(): Id {
        return this._id;
    }

    get bankCode(): string {
        return this._bankCode;
    }

    set bankCode(value: string) {
        this._bankCode = value;
    }

    get code(): string {
        return this._code;
    }

    set code(value: string) {
        this._code = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get value(): number {
        return this._value;
    }

    set value(newValue: number) {
        this._value = newValue;
    }

    get weight(): number {
        return this._weight;
    }

    set weight(value: number) {
        this._weight = value;
    }
}
